import { createContext } from 'react';

export const SchoolContext = createContext([]);

export const CognitoUserContext = createContext({});

export const UserInfoContext = createContext({});
